import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer">
        <span><b><span style="color: orange">LX</span>Harvest &copy; LXTech</b></span>
    </div>`
})
export class AppFooter {}